












import { Component, Vue } from 'vue-property-decorator';
import LoginForm from './components/LoginForm.vue';
import { mapGetters } from 'vuex';
import users from '@/store/modules/users';

@Component({
  components: {
    LoginForm,
  },
})
export default class Auth extends Vue {
  private errMessage = '';
  private loading = false;

  private async mounted() {
    if (users.isAuthenticated) {
      this.$router.push({ name: 'setup' });
    }
  }

  private setError(err: string) {
    this.errMessage = err;
  }
}
